;
define("facets_item_cell_grid.tpl", function(){});

